// src/api/catalogoApi.js
//
// CRUD del catálogo de productos del negocio y catálogos maestros.

import { api } from './apiClient';

export const catalogo = {
  // ── Mis productos (negocio autenticado) ──────────────
  // Se reutiliza el endpoint de listar productos por negocioId con el
  // id del propio negocio autenticado (obtenido en la sesión).

  producto:      (id)      => api.get(`/api/holaveci/productos/${id}`),
  crear:         (payload) => api.post('/api/holaveci/productos', payload),
  actualizar:    (id, payload) => api.put(`/api/holaveci/productos/${id}`, payload),
  eliminar:      (id)      => api.delete(`/api/holaveci/productos/${id}`),

  /** Borrado masivo del catálogo del negocio (pide confirmación fuerte). */
  reiniciarTodo: () => api.delete('/api/holaveci/mi-negocio/productos'),

  /** Carga la plantilla del tipo de negocio (embebida en el backend). */
  cargarPlantilla: () => api.post('/api/holaveci/mi-negocio/productos/plantilla', {}),

  /** Importa una lista de productos (backup .hvc del propio tendero). */
  importar: (productos) => api.post('/api/holaveci/mi-negocio/productos/importar', productos),

  // ── Catálogo maestro compartido (mig 029) ────────────
  /** Devuelve categorías del catálogo maestro por tipo de negocio. */
  categoriasCatalogo: (tipoNegocio) =>
    api.get('/api/holaveci/categorias-producto', {
      query: { tipoNegocio },
    }),
};
